import { Form, Input } from 'formik-antd';

export const CommentCell = ({ index }) => {
  return (
    <Form.Item name={`timeSheetEntryPerActivities.${index}.comments`}>
      <Input.TextArea maxLength={500} showCount name={`timeSheetEntryPerActivities.${index}.comments`}></Input.TextArea>
    </Form.Item>
  );
};
